export enum EStorageUrls {
  STORAGE = 'storage',
  FILES = 'files',
  FILES_SECURE = 'files-application-doc',
}
